import React, { useEffect } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Metadata } from '@thd-olt-component-react/metadata';
import { RETURN_METHOD } from '@src/constants/general';
import { useReturnStore } from '../stores/returnStore';
import { getReturnSummaryFieldsFromStorage } from '../utils/storage-helper';
import { ReturnSummary } from '../components/return-summary/ReturnSummary';
import { PageLayout } from '../components/shared/PageLayout';
import { setSummarySession, useSummaryStore } from '../stores/summaryStore';
import { triggerQualtricsSurvey } from '../utils/general';
import '../styles/returns.scss';
export var ReturnSummaryPage = function (_a) {
    var customerRole = _a.customerRole, customerType = _a.customerType;
    var orderId = useSummaryStore(function (state) { return state.orderId; });
    var refundValues = useSummaryStore(function (state) { return state.refundValues; });
    var returnMethod = useSummaryStore(function (state) { return state.returnMethod; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    useEffect(function () {
        getReturnSummaryFieldsFromStorage().then(function (returnSummaryFields) {
            if (!returnSummaryFields)
                return;
            setSummarySession(returnSummaryFields);
            triggerQualtricsSurvey();
        });
    }, []);
    var nonGuestCrumbs = [
        {
            path: '/myaccount/purchase-history',
            label: 'Purchase History',
        },
        {
            path: orderDetailsPath,
            label: 'Order Details',
        },
        {
            label: 'Return Summary',
            path: '/myaccount/return-summary',
        },
    ];
    var guestCrumbs = [
        {
            path: '/myaccount/guest-order-tracking',
            label: 'Track Your Order',
        },
        {
            label: 'Return Summary',
            path: '/myaccount/return-summary',
        },
    ];
    var crumbs = useAccountCrumbs(isMilitaryExchangeGuest ? guestCrumbs : nonGuestCrumbs);
    // These tags will be used so Qualtrics can inject their survey component on a successful return on page render
    var QualtricsSucessReturnSurvey = (React.createElement(ErrorBoundary, null,
        React.createElement("input", { type: "hidden", id: "OrderNumberId", value: orderId }),
        returnMethod === RETURN_METHOD.UPS_DROP_OFF && (React.createElement("div", { id: "ReturnsExperience", className: "qualtrics-survey" })),
        returnMethod === RETURN_METHOD.LORP && (React.createElement("div", { id: "LORPXPsurvey", className: "qualtrics-survey" }))));
    return (React.createElement(PageLayout, { crumbs: crumbs, customerRole: customerRole, customerType: customerType, pageTitle: "Return Items" },
        React.createElement(React.Fragment, null,
            React.createElement(Metadata, { title: "The Home Depot" }),
            orderId && React.createElement(ReturnSummary, { refundValues: refundValues }),
            QualtricsSucessReturnSurvey)));
};
ReturnSummaryPage.displayName = 'Return Summary';
